import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { MachineConnectionStatus } from "@octopusdeploy/octopus-server-client";
import { noOp } from "@octopusdeploy/utilities";
import React from "react";
import TaskLogLines from "~/components/TaskLogLines/TaskLogLines";
import SectionHeading from "~/primitiveComponents/dataDisplay/Section/SectionHeading";
interface CommunicationLogsProps {
    connectionStatus: MachineConnectionStatus;
}
const styles = {
    commsLogsSection: css({
        padding: `${space[8]} ${space[16]}`,
    }),
};
export function CommunicationLogs({ connectionStatus }: CommunicationLogsProps) {
    if (connectionStatus.Logs?.length === 0) {
        return null;
    }
    return (<>
            <SectionHeading title="Recent Communication Logs"/>
            <section className={styles.commsLogsSection}>
                <TaskLogLines lines={connectionStatus.Logs} showTimestamps={true} onFetchRange={noOp} isFetchDisabled={true}/>
            </section>
        </>);
}
